import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendSampleSpecification,
	FrontendUserInfo,
	FrontendUserLicense,
} from "node-library/dist/portal";
import { SampleMatrix } from "node-library/dist/constants";
import { FolderIcon } from "../../../common-components/svgIcons";
import { getMatrixTranslationText } from "../../../helpers/sampleHelper";
import { SecondaryColor } from "node-library/dist/colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface Props {
	label: string;
	icon: React.ReactNode;
	index: number;

	onRowClick?: () => void;
	selected: boolean;
	children?: Array<React.ReactNode>;
	// userSpecifications: Array<FrontendSampleSpecification>;
	// setUserSpecifications: React.Dispatch<
	// 	React.SetStateAction<Array<FrontendSampleSpecification>>
	// >;
}

export default function SpecificationFolderRow(props: Props) {
	const { t: translation } = useTranslation();

	const [uploadSpecModalOpen, setUploadSpecModalOpen] =
		useState<boolean>(false);

	const [expanded, setExpanded] = useState<boolean>(false);

	const handleClick = () => {
		// If onRowClick is provided, call it
		if (props.onRowClick) {
			props.onRowClick();
		}

		// Toggle the expanded state
		setExpanded(!expanded);
	};

	return (
		<div>
			<div
				key={props.index}
				className={`profile-spec-matrix-folder-row ${
					props.selected ? `profile-spec-matrix-folder-row-selected` : ``
				}`}
				onClick={handleClick}
			>
				<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
					{props.icon}
					<div className="typography-body-02">{props.label}</div>
				</div>

				{props.children &&
					(expanded ? (
						<KeyboardArrowDownIcon style={{ fontSize: "18px" }} />
					) : (
						<KeyboardArrowRightIcon style={{ fontSize: "18px" }} />
					))}
			</div>

			{props.children && expanded && (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "2px",
						margin: "2px 0px 2px 32px",
					}}
				>
					{props.children}
				</div>
			)}
		</div>
	);
}
